import React from 'react';
const AuthContext = React.createContext(undefined);
/**
 * Hook to access the authentication context
 */
export const useAuth = () => {
    const context = React.useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
/**
 * Provider for the authentication context
 */
export const AuthProvider = ({ children, getToken }) => (React.createElement(AuthContext.Provider, { value: { getToken } }, children));
//# sourceMappingURL=AuthContext.js.map